import { useMemo } from 'react';
import { useNSFWSettings } from './use-nsfw-settings';
import { Product } from '@/types';
import { NSFW_TAGS, getNSFWCategory } from '../constants/nsfw-tags';

export function useNSFWBlur(product?: Product) {
  const { settings } = useNSFWSettings();
  
  const tags = useMemo(() => 
    product?.tag_slugs ?? product?.tags?.map(tag => tag.slug) ?? [], 
    [product]
  );

  const nsfwCategory = useMemo(() => {
    for (const tag of tags) {
      const category = getNSFWCategory(tag);
      if (category) return category;
    }
    return null;
  }, [tags]);

  const isNSFW = nsfwCategory !== null;
  const shouldBlur = isNSFW && (
    (nsfwCategory === 'explicit' && !settings.explicit) || 
    (nsfwCategory === 'mature' && !settings.mature) ||
    !settings.confirmed18
  );

  return {
    isNSFW,
    nsfwCategory,
    shouldBlur,
    settings
  };
} 